<template>
  <div
    class="article-card main-blog__article"
    :class="loading ? 'is-loading' : ''"
  >
    <a :href="article.onlineStoreUrl">
      <span class="visually-hidden" v-text="article.title"></span>

      <responsive-image
        class="article-card__image-container"
        :image="loading ? '' : article.image"
        :ratio="squareRatio ? '1:1' : '3:2'"
        :ratio-desktop="squareRatio ? '16:9' : '3:2'"
        sizes="(min-width: 768px) 50vw, (min-width: 1024px) 33vw, 100vw"
      />
    </a>

    <div class="article-card__footer">
      <h2
        class="article-card__title text-heading-s text-heading-m-desktop"
        v-text="article.title"
      ></h2>

      <p
        v-if="showExcerpt"
        class="article-card__excerpt text-body-s-regular text-body-m-regular-desktop"
        v-text="articleExcerptOrContent"
      ></p>
      <p
        v-if="showDate"
        class="article-card__date text-mobile-paragraph-xs-regular text-desktop-paragraph-xs-regular"
        v-text="articleDate"
      ></p>
    </div>
  </div>
</template>

<script>
/**
 * Vue: Blog tags (main-blog)
 * -----------------------------------------------------------------------------
 * Scrolls active blog tag into view.
 *
 */
import ResponsiveImage from '~global/images/responsive-image.vue';
import { stripHtml, truncateWords } from '~/helpers/text';

export default {
  name: 'ArticleCard',

  components: {
    ResponsiveImage,
  },

  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showExcerpt: {
      type: Boolean,
      default: true,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
    squareRatio: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    articleDate() {
      if (!this.showDate) return false;
      const publishedDate = new Date(this.article.publishedAt);
      return this.$formatDate('date_formats.day_month_year', publishedDate);
    },

    articleExcerptOrContent() {
      if (!this.showExcerpt) return false;

      const articleText =
        this.article.excerpt === ''
          ? this.article.content
          : this.article.excerpt;
      return truncateWords(stripHtml(articleText), 20, '...');
    },
  },
};
</script>

<style lang="scss">
@import './article-card';
</style>
